import {
    Box,
    Button,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import {ArrowForward, ArrowRight, CheckCircleOutline, Search, SignalCellularNullRounded} from "@material-ui/icons";
import {Autocomplete} from "@material-ui/lab";
import {makeStyles} from '@material-ui/core/styles';
import {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    getBatchCountByWarehouse,
    getOrderCountBySubBatch,
    getRecentSubBatches,
    getStatesInBatch,
    transferPackagesByWarehouseOrState,
    getBatchCountByPortWarehouse
} from "../../../actions/workflowAction";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {getUserPreference} from "../../../utilities/common";
import {green} from "@material-ui/core/colors";
import _ from "lodash";
import {useAlert} from "../../../utilities/hooks";
import {alertType} from "../../Common/UniAlert/context";
import {useTranslation} from "react-i18next";
import FullscreenLoading from "../../Common/FullscreenLoading";
import {DataGrid} from "@material-ui/data-grid";

const useStyles = makeStyles((theme) => ({
        row: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
        },
        verticalMargin: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        textSpace: {
            marginRight: theme.spacing(1)
        }
    }))

;

export default function SelectBatchBar(props) {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const alertDialog = useAlert();

    const validBatchNumberRegex = /^[A-Z]+SUB-20\d{10}$/


    const [subBatches, setSubBatches] = useState([]);
    const [subBatchesLoading, setSubBatchesLoading] = useState(false);

    const [subBatch, setSubBatch] = useState(null);
    const [subBatchTyped, setSubBathTyped] = useState("");


    return (
        <Box>


            <div className={classes.row} style={{marginBottom: 8}}>
                {!props.stepOneComplete ? <ArrowRight color='primary'/> :
                    <CheckCircleOutline style={{color: green[500]}}/>}
                <Typography className={classes.textSpace}>Step 1:</Typography>
                <Autocomplete
                    id="autocomplete-batches"
                    freeSolo
                    onOpen={() => fetchSubBatches()}
                    onClose={() => setSubBatches([])}
                    onChange={(event, value) => {
                        console.log(value);
                        setSubBatch(value);
                        setSubBathTyped("");
                        props.handleSubBatch(value)
                        props.handleSubBatchTyped("")
                    }}
                    onInputChange={(event, value) => {
                        console.log(value);
                        setSubBatch(value);
                        setSubBathTyped(null)
                        props.handleSubBatchTyped(value);
                        props.handleSubBatch(null)
                    }}
                    loading={subBatchesLoading}
                    options={subBatches}
                    style={{width: 300}}
                    renderInput={(params) => <TextField {...params} label="Select Batch" variant="outlined"/>}
                />


            </div>
        </Box>
    )


    async function fetchSubBatches() {
        setSubBatchesLoading(true)
        try {
            let result = await dispatch(getRecentSubBatches(userPref.userCity, 30))
            setSubBatches(result)
            setSubBatchesLoading(false)
        } catch (error) {
            setSubBatchesLoading(false)
            dispatch(showAlertSnackbar({title: 'Cannot Load SubBatches'}))
        }
    }


}